/**
 * @module components/modals/Toast
 * @summary Transient toast host (subscribes to the engine's toast bus).
 * @ported-from JCC PFD Engineering Tool v1.1.html lines 145-153 + showToast (4023).
 */
import { useEffect, useRef, useState } from 'react';
import { onToast } from '../../lib/toast';

export function Toast() {
  const [msg, setMsg] = useState('');
  const [show, setShow] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    const off = onToast((m, ms) => {
      setMsg(m);
      setShow(true);
      if (timer.current) clearTimeout(timer.current);
      timer.current = setTimeout(() => setShow(false), ms);
    });
    return () => {
      off();
      if (timer.current) clearTimeout(timer.current);
    };
  }, []);

  return (
    <div id="toast" className={show ? 'show' : ''}>
      {msg}
    </div>
  );
}
